import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import { CircularProgress } from '@mui/material';
import { useGetCreditSubFeatureQuery } from '../../redux/services/settings/CreditsService';
import { useCreditHistoryQuery } from '../../redux/services/settings/BillingService';
import InsufficientCreditsModal from '../common/InsufficientCreditsModal';

const ComposeEmailDrawer = ({ open, onClose, candidate, onSend, isFollowUp = false, subject, message, error }) => {
  // const currentJobTitle = candidate?.workHistory?.[0]?.title || candidate?.title || 'Professional';
  // const currentCompany = candidate?.workHistory?.[0]?.company || 'your organization';
  // console.log(candidate);

  //   const initialEmailBody = isFollowUp 
  //     ? `Hi ${candidate?.full_name || 'Candidate'},

  // I wanted to follow up on my previous message regarding the ${currentJobTitle} opportunity.

  // I understand you may be busy, but I believe your experience at ${currentCompany} makes you an excellent fit for this role.

  // Would you have 15 minutes this week for a quick call?

  // Looking forward to hearing from you.

  // Best regards,
  // [Your Name]
  // [Your Company]`
  //     : `Hi ${candidate?.full_name || 'Candidate'},

  // I came across your profile and was impressed by your experience as a ${currentJobTitle} at ${currentCompany}.

  // We have an exciting opportunity that I believe aligns well with your background and expertise. I would love to schedule a brief call to discuss how your skills could be a great fit for our team.

  // Would you be available for a 15-minute conversation this week?

  // Looking forward to hearing from you.

  // Best regards,
  // [Your Name]
  // [Your Company]`;

  //   const initialSubject = isFollowUp 
  //     ? `Following up: ${currentJobTitle} Opportunity`
  //     : `Exciting Opportunity for ${currentJobTitle} Role`;

  const [emailSubject, setEmailSubject] = useState(subject || '');
  const [emailBody, setEmailBody] = useState(message || '');
  const { data: creditsData, refetch: refetchCreditsData, error: creditsError, isLoading: creditCheckLoading, isFetching: creditCheckFetching } = useGetCreditSubFeatureQuery({ featureCode: 'AI_CREDITS', subFeatureCode: 'AI_Outreach_Email_Follow_ups' });
  const { data: creditHistory } = useCreditHistoryQuery();
  const availableCredits = creditHistory?.available_credit || 0;
  const [openCreditModal, setOpenCreditModal] = useState(false);


  // Update local state when props change
  useEffect(() => {
    if (subject !== undefined) setEmailSubject(subject);
    if (message !== undefined) setEmailBody(message);
  }, [subject, message]);

  useEffect(() => {
    if (open) {
      refetchCreditsData();
    }
  }, [open, openCreditModal]);

  // Handle credit check validation upon opening
  useEffect(() => {
    if (open && !creditCheckLoading && !creditCheckFetching) {
      const isAvailable = creditsData?.data?.is_available ?? creditsData?.is_available ?? creditsError?.data?.is_available;
      if (isAvailable === false || creditsError?.status === 402) {
        setOpenCreditModal(true);
      }
    }
  }, [open]);

  const handleSend = () => {
    onSend({
      subject: emailSubject,
      body: emailBody
    });
    // onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      ModalProps={{
        BackdropProps: {
          sx: { bgcolor: 'rgba(0, 0, 0, 0.5)' }
        }
      }}
      PaperProps={{
        sx: {
          width: 384,
          height: '93vh',
          display: 'flex',
          flexDirection: 'column',
          mt: 8
        }
      }}
    >
      {/* Header */}
      <Box sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: 1,
        borderColor: 'divider'
      }}>
        <Typography variant="h6" fontWeight={600}>
          {isFollowUp ? 'Compose Follow-up' : 'Compose Email'}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
        {/* Recipient Info */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
            To
          </Typography>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            bgcolor: 'rgba(0, 0, 0, 0.02)',
            borderRadius: 2,
            p: 1.5
          }}>
            <PersonIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
            <Box>
              <Typography variant="body2" fontWeight={500}>
                {candidate?.full_name}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <EmailIcon sx={{ fontSize: 12 }} />
                {candidate?.email || 'email@hidden.com'}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        {(() => {
          // if (error) {
          //   return (
          //     <Box sx={{ 
          //       display: 'flex', 
          //       flexDirection: 'column', 
          //       alignItems: 'center', 
          //       justifyContent: 'center', 
          //       p: 4,
          //       textAlign: 'center'
          //     }}>
          //       <Typography color="error" variant="subtitle1" sx={{ mb: 2 }}>
          //         {error.message || 'Failed to generate email content'}
          //       </Typography>
          //     </Box>
          //   );
          // }

          // if (error) {
          //   return (
          //     <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          //       <CircularProgress disableShrink />
          //     </Box>
          //   );
          // }

          return (
            <>
              {/* Subject */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
                  Subject
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={emailSubject}
                  onChange={(e) => setEmailSubject(e.target.value)}
                  placeholder="Enter email subject"
                />
              </Box>

              {/* Email Body */}
              <Box>
                <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
                  Message
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={14}
                  value={emailBody}
                  onChange={(e) => setEmailBody(e.target.value)}
                  placeholder="Write your message..."
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: '0.875rem',
                      lineHeight: 1.6
                    }
                  }}
                />
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                  ✨ This message was generated using AI based on candidate profile
                </Typography>
              </Box>

              {/* Footer Actions */}
              <Box sx={{
                mt: 3,
                pt: 2,
                borderTop: 1,
                borderColor: 'divider',
                display: 'flex',
                gap: 1.5
              }}>
                <Button
                  variant="outlined"
                  onClick={onClose}
                  sx={{ flex: 1 }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  startIcon={<SendIcon />}
                  onClick={handleSend}
                  sx={{ flex: 1 }}
                >
                  {isFollowUp ? 'Send Follow-up' : 'Send Email'}
                </Button>
              </Box>
            </>
          );
        })()}
      </Box>

      {/* Insufficient AI Credits Modal */}
      <InsufficientCreditsModal
        open={openCreditModal}
        onClose={() => {
          setOpenCreditModal(false);
        }}
        availableCredits={availableCredits}
        totalCredit={creditHistory?.total_credit}
        cost={creditsData?.data?.required_credit ?? creditsError?.data?.required_credit ?? 1}
      />
    </Drawer>
  );
};

ComposeEmailDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  candidate: PropTypes.shape({
    full_name: PropTypes.string,
    email: PropTypes.string,
    workHistory: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      company: PropTypes.string
    })),
    title: PropTypes.string
  }).isRequired,
  onSend: PropTypes.func.isRequired,
  isFollowUp: PropTypes.bool,
  subject: PropTypes.string,
  message: PropTypes.string
};

ComposeEmailDrawer.defaultProps = {
  isFollowUp: false,
  subject: '',
  message: ''
};

export default ComposeEmailDrawer;
